import { Directive } from '@angular/core';

@Directive({
  selector: '[libItemContainer]'
})
export class ItemContainerDirective {}
